















import {Component, Prop, Vue} from "vue-property-decorator";
import RenderProductPrice from "@/components/Shared/RenderProductPrice.vue";
import RenderProductStatus from "@/components/Shared/RenderProductStatus.vue";
import WishlistItem from "@/api/WishlistItem";
import WishlistService from "@/service/WishlistService";
import Message from "@/api/Message";

@Component
export default class MessageView extends Vue {
  @Prop() private message!: Message;
}
